/*! sgp-cart-pairing.js v0.0.0 sha256:b5a0441887911342a97917406ca345c2e70c7687e8cdb43140ddb9e25f0fb4d7
 * Built from packages/cart-script (silvergrain-studio). DO NOT EDIT the
 * theme copy: change source here, rebuild, re-vendor (VENDORING.md). */
"use strict";
(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // src/cart.ts
  var CartParseError = class extends Error {
    constructor(message) {
      super(`cart.js parse error: ${message}`);
      this.name = "CartParseError";
    }
  };
  function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
  }
  function parseLine(raw, index) {
    if (!isRecord(raw)) {
      throw new CartParseError(`items[${index}] is not an object`);
    }
    const key = raw.key;
    if (typeof key !== "string" || key.length === 0) {
      throw new CartParseError(`items[${index}].key missing or empty`);
    }
    const id = raw.id;
    if (typeof id !== "number" || !Number.isFinite(id)) {
      throw new CartParseError(`items[${index}].id is not a number`);
    }
    const quantity = raw.quantity;
    if (typeof quantity !== "number" || !Number.isInteger(quantity) || quantity < 0) {
      throw new CartParseError(`items[${index}].quantity is not a non-negative integer`);
    }
    const rawProperties = raw.properties;
    let properties;
    if (rawProperties === null || rawProperties === void 0) {
      properties = {};
    } else if (isRecord(rawProperties)) {
      properties = { ...rawProperties };
    } else {
      throw new CartParseError(`items[${index}].properties is neither object nor null`);
    }
    const rawPrice = raw.final_line_price;
    const final_line_price = typeof rawPrice === "number" && Number.isFinite(rawPrice) ? rawPrice : 0;
    const title = typeof raw.title === "string" ? raw.title : null;
    return {
      // The ONE brand application in the package: a key string taken from a
      // live /cart.js body becomes a CartLineKey here and nowhere else (§5).
      key,
      id,
      quantity,
      properties,
      final_line_price,
      title
    };
  }
  function parseCart(raw) {
    if (!isRecord(raw)) {
      throw new CartParseError("body is not an object");
    }
    const rawItems = raw.items;
    if (!Array.isArray(rawItems)) {
      throw new CartParseError("items is not an array");
    }
    const item_count = raw.item_count;
    if (typeof item_count !== "number" || !Number.isInteger(item_count) || item_count < 0) {
      throw new CartParseError("item_count is not a non-negative integer");
    }
    return {
      token: typeof raw.token === "string" ? raw.token : null,
      item_count,
      currency: typeof raw.currency === "string" ? raw.currency : null,
      items: rawItems.map((line, index) => parseLine(line, index))
    };
  }

  // src/client.ts
  function changeByKey(key, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) {
      throw new RangeError(`changeByKey quantity must be a non-negative integer, got ${quantity}`);
    }
    return { kind: "change", id: key, quantity };
  }
  var CartRequestError = class extends Error {
    constructor(message, status, url) {
      super(`cart request failed (${status != null ? status : "network"}) ${url}: ${message}`);
      __publicField(this, "status", status);
      __publicField(this, "url", url);
      this.name = "CartRequestError";
    }
  };
  var DEFAULT_TIMEOUT_MS = 1e4;
  function extractSections(payload) {
    if (typeof payload !== "object" || payload === null || Array.isArray(payload)) {
      return null;
    }
    const raw = payload.sections;
    if (typeof raw !== "object" || raw === null || Array.isArray(raw)) {
      return null;
    }
    const rendered = {};
    for (const [id, html] of Object.entries(raw)) {
      if (typeof html === "string") {
        rendered[id] = html;
      }
    }
    return rendered;
  }
  function createCartClient(options = {}) {
    var _a, _b, _c;
    const fetchImpl = (_a = options.fetch) != null ? _a : ((url, init) => globalThis.fetch(url, init));
    const base = (_b = options.baseUrl) != null ? _b : "";
    const timeoutMs = (_c = options.timeoutMs) != null ? _c : DEFAULT_TIMEOUT_MS;
    async function request(url, init) {
      var _a2;
      const controller = typeof AbortController === "function" ? new AbortController() : null;
      const timer = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;
      try {
        return await fetchImpl(url, {
          method: (_a2 = init == null ? void 0 : init.method) != null ? _a2 : "GET",
          headers: {
            Accept: "application/json",
            ...(init == null ? void 0 : init.body) !== void 0 ? { "Content-Type": "application/json" } : {}
          },
          ...(init == null ? void 0 : init.body) !== void 0 ? { body: init.body } : {},
          ...controller ? { signal: controller.signal } : {}
        });
      } finally {
        if (timer !== null) {
          clearTimeout(timer);
        }
      }
    }
    async function getCartOnce() {
      const url = `${base}/cart.js`;
      let response;
      try {
        response = await request(url);
      } catch (error) {
        throw new CartRequestError(String(error), null, url);
      }
      if (!response.ok) {
        throw new CartRequestError("non-2xx", response.status, url);
      }
      return parseCart(await response.json());
    }
    return {
      async getCart() {
        try {
          return await getCartOnce();
        } catch (error) {
          if (error instanceof CartRequestError && (error.status === null || error.status >= 500)) {
            return getCartOnce();
          }
          throw error;
        }
      },
      async perform(planned) {
        const url = planned.kind === "add" ? `${base}/cart/add.js` : `${base}/cart/change.js`;
        const sectionsField = options.sections && options.sections.ids.length > 0 ? {
          sections: options.sections.ids.join(","),
          sections_url: options.sections.url
        } : {};
        const body = planned.kind === "add" ? JSON.stringify({ items: planned.items, ...sectionsField }) : JSON.stringify({ id: planned.id, quantity: planned.quantity, ...sectionsField });
        let response;
        try {
          response = await request(url, { method: "POST", body });
        } catch (error) {
          throw new CartRequestError(String(error), null, url);
        }
        if (!response.ok) {
          throw new CartRequestError("non-2xx", response.status, url);
        }
        if (options.sections) {
          try {
            const payload = await response.json();
            const rendered = extractSections(payload);
            if (rendered !== null) {
              options.sections.onSections(rendered);
            }
          } catch (e) {
          }
        }
      }
    };
  }

  // src/queue.ts
  function createCartQueue(client) {
    const queue = [];
    let busy = false;
    let ownUpdate = false;
    let snapshot = null;
    let seq = 0;
    const observers = /* @__PURE__ */ new Set();
    let drainWaiters = [];
    function notifyDrained() {
      const waiters = drainWaiters;
      drainWaiters = [];
      for (const resolve of waiters) {
        resolve();
      }
    }
    async function executeOp(op) {
      var _a;
      let requestCount = 0;
      let ok = true;
      let error = null;
      let terminal;
      try {
        const fresh = await client.getCart();
        const requests = op.plan(fresh);
        requestCount = requests.length;
        if (requests.length === 0) {
          terminal = fresh;
        } else {
          ownUpdate = true;
          for (const request of requests) {
            await client.perform(request);
          }
          terminal = await client.getCart();
        }
      } catch (caught) {
        ok = false;
        error = caught;
        terminal = await client.getCart().catch(() => null);
      }
      if (terminal !== null) {
        snapshot = terminal;
        seq += 1;
        for (const observer of [...observers]) {
          observer(terminal, seq);
        }
      }
      ownUpdate = false;
      (_a = op.onSettled) == null ? void 0 : _a.call(op, { ok, opName: op.name, error, cart: snapshot, requestCount });
    }
    async function drain() {
      busy = true;
      try {
        while (queue.length > 0) {
          const op = queue.shift();
          if (op === void 0) {
            break;
          }
          await executeOp(op);
        }
      } finally {
        busy = false;
        notifyDrained();
      }
    }
    return {
      enqueue(op) {
        if (op.coalesceKey !== null) {
          const index = queue.findIndex((queued) => queued.coalesceKey === op.coalesceKey);
          if (index >= 0) {
            queue[index] = op;
            return;
          }
        }
        queue.push(op);
        if (!busy) {
          void drain();
        }
      },
      subscribe(observer) {
        observers.add(observer);
        return () => {
          observers.delete(observer);
        };
      },
      isOwnUpdate() {
        return ownUpdate;
      },
      snapshot() {
        return snapshot;
      },
      seq() {
        return seq;
      },
      pending() {
        return queue.length;
      },
      idle() {
        if (!busy && queue.length === 0) {
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          drainWaiters.push(resolve);
        });
      }
    };
  }

  // src/storeRoot.ts
  var LOCALE_ROOT = /^\/(?:[a-z]{2,3}(?:-[a-z]{2,8})?\/)?$/i;
  function readStoreRoot(host) {
    var _a, _b;
    const source = host === void 0 ? typeof window === "undefined" ? null : window : host;
    const raw = (_b = (_a = source == null ? void 0 : source.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root;
    if (typeof raw !== "string") return "";
    const trimmed = raw.trim();
    if (!LOCALE_ROOT.test(trimmed)) return "";
    return trimmed.replace(/\/+$/, "");
  }

  // src/predicates.ts
  var ADDON_PROPERTY = "_sgAddon";
  var PROJECT_PROPERTY = "_sgProjectId";
  var EXTRA_PER_COPY_PROPERTY = "_sgExtraPerCopy";
  function isAddonLine(line) {
    const value = line.properties[ADDON_PROPERTY];
    return value === true || value === "true";
  }
  function projectIdOf(line) {
    const value = line.properties[PROJECT_PROPERTY];
    return typeof value === "string" && value.length > 0 ? value : null;
  }
  function isStudioLine(line) {
    return projectIdOf(line) !== null && !isAddonLine(line);
  }
  function extraPerCopyOf(line) {
    const value = line.properties[EXTRA_PER_COPY_PROPERTY];
    if (typeof value === "number") {
      return Number.isInteger(value) && value >= 0 ? value : null;
    }
    if (typeof value === "string" && /^\d+$/.test(value.trim())) {
      return Number.parseInt(value.trim(), 10);
    }
    return null;
  }
  function groupByProject(cart) {
    const projects = /* @__PURE__ */ new Map();
    const unboundAddonLines = [];
    const foreignLines = [];
    for (const line of cart.items) {
      const projectId = projectIdOf(line);
      if (isAddonLine(line)) {
        if (projectId === null) {
          unboundAddonLines.push(line);
        } else {
          getGroup(projects, projectId).addonLines.push(line);
        }
      } else if (projectId !== null) {
        getGroup(projects, projectId).studioLines.push(line);
      } else {
        foreignLines.push(line);
      }
    }
    return { projects, unboundAddonLines, foreignLines };
  }
  function getGroup(projects, projectId) {
    let group = projects.get(projectId);
    if (!group) {
      group = { projectId, studioLines: [], addonLines: [] };
      projects.set(projectId, group);
    }
    return group;
  }

  // src/counts.ts
  function correctedItemCount(cart) {
    let addonQuantity = 0;
    for (const line of cart.items) {
      if (isAddonLine(line)) {
        addonQuantity += line.quantity;
      }
    }
    return cart.item_count - addonQuantity;
  }
  function mergedPairDisplay(book, addon) {
    return {
      quantity: book.quantity,
      final_price: book.final_line_price + (addon === null ? 0 : addon.final_line_price)
    };
  }

  // src/scan.ts
  var ACTIONABLE = /* @__PURE__ */ new Set([
    "quantity-incoherent",
    "orphan-addon",
    "orphan-addon-unbound"
  ]);
  function isActionableVerdict(verdict) {
    return ACTIONABLE.has(verdict.kind);
  }
  function isWarnVerdict(verdict) {
    return verdict.kind === "missing-addon" || verdict.kind === "mirror-mismatch" || verdict.kind === "duplicate-lines";
  }
  function scanCart(cart) {
    const verdicts = [];
    const grouped = groupByProject(cart);
    for (const group of grouped.projects.values()) {
      const { projectId, studioLines, addonLines } = group;
      if (studioLines.length === 0) {
        verdicts.push({ kind: "orphan-addon", projectId });
        continue;
      }
      if (studioLines.length > 1 || addonLines.length > 1) {
        verdicts.push({ kind: "duplicate-lines", projectId });
        continue;
      }
      const book = studioLines[0];
      const addon = addonLines.length === 1 ? addonLines[0] : null;
      const bookExtraPerCopy = extraPerCopyOf(book);
      if (addon === null) {
        if (bookExtraPerCopy === null || bookExtraPerCopy === 0) {
          verdicts.push({ kind: "coherent", projectId });
        } else {
          verdicts.push({ kind: "missing-addon", projectId });
        }
        continue;
      }
      const addonExtraPerCopy = extraPerCopyOf(addon);
      if (bookExtraPerCopy === null || addonExtraPerCopy === null || bookExtraPerCopy !== addonExtraPerCopy) {
        verdicts.push({
          kind: "mirror-mismatch",
          projectId,
          bookExtraPerCopy,
          addonExtraPerCopy
        });
        continue;
      }
      const expectedAddonQuantity = book.quantity * bookExtraPerCopy;
      if (addon.quantity !== expectedAddonQuantity) {
        verdicts.push({
          kind: "quantity-incoherent",
          projectId,
          expectedAddonQuantity,
          actualAddonQuantity: addon.quantity
        });
      } else {
        verdicts.push({ kind: "coherent", projectId });
      }
    }
    if (grouped.unboundAddonLines.length > 0) {
      verdicts.push({ kind: "orphan-addon-unbound", lineCount: grouped.unboundAddonLines.length });
    }
    return { verdicts };
  }
  function coupleOp(projectId) {
    return {
      name: `couple:${projectId}`,
      coalesceKey: `couple:${projectId}`,
      plan(cart) {
        const group = groupByProject(cart).projects.get(projectId);
        if (!group || group.studioLines.length !== 1 || group.addonLines.length !== 1) {
          return [];
        }
        const book = group.studioLines[0];
        const addon = group.addonLines[0];
        const bookExtraPerCopy = extraPerCopyOf(book);
        const addonExtraPerCopy = extraPerCopyOf(addon);
        if (bookExtraPerCopy === null || addonExtraPerCopy === null || bookExtraPerCopy !== addonExtraPerCopy) {
          return [];
        }
        const expected = book.quantity * bookExtraPerCopy;
        if (addon.quantity === expected) {
          return [];
        }
        return [changeByKey(addon.key, expected)];
      }
    };
  }
  function healOrphanOp(projectId) {
    return {
      name: `heal:${projectId}`,
      coalesceKey: `heal:${projectId}`,
      plan(cart) {
        const group = groupByProject(cart).projects.get(projectId);
        if (!group || group.studioLines.length > 0) {
          return [];
        }
        return group.addonLines.map((addon) => changeByKey(addon.key, 0));
      }
    };
  }
  function healUnboundAddonsOp() {
    return {
      name: "heal:@unbound",
      coalesceKey: "heal:@unbound",
      plan(cart) {
        return groupByProject(cart).unboundAddonLines.map((addon) => changeByKey(addon.key, 0));
      }
    };
  }
  function opsForScan(result) {
    const ops = [];
    for (const verdict of result.verdicts) {
      switch (verdict.kind) {
        case "quantity-incoherent":
          ops.push(coupleOp(verdict.projectId));
          break;
        case "orphan-addon":
          ops.push(healOrphanOp(verdict.projectId));
          break;
        case "orphan-addon-unbound":
          ops.push(healUnboundAddonsOp());
          break;
        default:
          break;
      }
    }
    return ops;
  }

  // src/dom.ts
  var CART_SURFACE_WARN_COPY = "This design needs updating before checkout. Use Edit design to refresh it.";
  var STALE_FLAG_PREFIX = "sg-basket-stale:";
  function readStaleProjects(cart, storage) {
    const stale = /* @__PURE__ */ new Set();
    if (storage === null) {
      return stale;
    }
    for (const line of cart.items) {
      if (!isStudioLine(line)) {
        continue;
      }
      const projectId = projectIdOf(line);
      if (projectId === null || stale.has(projectId)) {
        continue;
      }
      try {
        if (storage.getItem(`${STALE_FLAG_PREFIX}${projectId}`) !== null) {
          stale.add(projectId);
        }
      } catch (e) {
      }
    }
    return stale;
  }
  var EMPTY_STALE_SET = /* @__PURE__ */ new Set();
  var MERGED_MARKER = "data-sg-merged";
  var ADDON_HIDDEN_MARKER = "data-sg-addon-hidden";
  var COUNT_MARKER = "data-sg-count";
  var CHECKOUT_DISABLED_MARKER = "data-sg-checkout-disabled";
  var WARN_MARKER = "data-sg-warn";
  var PROJECT_MARKER = "data-sg-project";
  function formatMinorUnits(amountMinor, currency, locale) {
    if (currency !== null) {
      try {
        return new Intl.NumberFormat(locale != null ? locale : void 0, {
          style: "currency",
          currency
        }).format(amountMinor / 100);
      } catch (e) {
      }
    }
    return (amountMinor / 100).toFixed(2);
  }
  var WriteBarrier = class {
    constructor() {
      __publicField(this, "writes", 0);
    }
    setAttribute(element, name, value) {
      if (element.getAttribute(name) !== value) {
        element.setAttribute(name, value);
        this.writes += 1;
      }
    }
    removeAttribute(element, name) {
      if (element.hasAttribute(name)) {
        element.removeAttribute(name);
        this.writes += 1;
      }
    }
    setText(element, text) {
      if (element.textContent !== text) {
        element.textContent = text;
        this.writes += 1;
      }
    }
  };
  function setQuantityValue(barrier, element, quantity) {
    const text = String(quantity);
    if (element.tagName === "INPUT") {
      const input = element;
      if (input.value !== text) {
        input.value = text;
        barrier.writes += 1;
      }
    } else {
      barrier.setText(element, text);
    }
  }
  function applyWarnElement(barrier, document2, block, config2, warned) {
    const existing = block.querySelector(`[${WARN_MARKER}]`);
    if (warned) {
      if (existing === null) {
        const warn = document2.createElement("p");
        warn.setAttribute(WARN_MARKER, "true");
        if (config2.warnClassName !== "") {
          warn.setAttribute("class", config2.warnClassName);
        }
        warn.textContent = CART_SURFACE_WARN_COPY;
        block.appendChild(warn);
        barrier.writes += 1;
      } else {
        barrier.setText(existing, CART_SURFACE_WARN_COPY);
      }
    } else if (existing !== null) {
      existing.remove();
      barrier.writes += 1;
    }
  }
  function applyCheckoutButtons(barrier, document2, config2, warnActive) {
    for (const selector of config2.checkoutButtonSelectors) {
      for (const button of document2.querySelectorAll(selector)) {
        if (warnActive) {
          if (button.hasAttribute("disabled") && !button.hasAttribute(CHECKOUT_DISABLED_MARKER)) {
            continue;
          }
          barrier.setAttribute(button, "disabled", "");
          barrier.setAttribute(button, "aria-disabled", "true");
          barrier.setAttribute(button, CHECKOUT_DISABLED_MARKER, "true");
        } else if (button.hasAttribute(CHECKOUT_DISABLED_MARKER)) {
          barrier.removeAttribute(button, "disabled");
          barrier.removeAttribute(button, "aria-disabled");
          barrier.removeAttribute(button, CHECKOUT_DISABLED_MARKER);
        }
      }
    }
  }
  function runDisplayPass(document2, cart, config2, staleProjectIds = EMPTY_STALE_SET) {
    const barrier = new WriteBarrier();
    const classification = groupByProject(cart);
    const scan = scanCart(cart);
    const locale = document2.documentElement.getAttribute("lang");
    const byKey = /* @__PURE__ */ new Map();
    for (const line of cart.items) {
      byKey.set(line.key, line);
    }
    const warnedProjects = /* @__PURE__ */ new Set();
    for (const verdict of scan.verdicts) {
      if (isWarnVerdict(verdict) && "projectId" in verdict) {
        warnedProjects.add(verdict.projectId);
      }
    }
    for (const projectId of staleProjectIds) {
      warnedProjects.add(projectId);
    }
    const warnActive = staleProjectIds.size > 0 || scan.verdicts.some((verdict) => isWarnVerdict(verdict));
    for (const block of document2.querySelectorAll(config2.lineItemSelector)) {
      const key = block.getAttribute(config2.lineKeyAttribute);
      if (key === null) {
        continue;
      }
      const line = byKey.get(key);
      if (line === void 0) {
        continue;
      }
      if (isAddonLine(line)) {
        barrier.setAttribute(block, "hidden", "");
        barrier.setAttribute(block, ADDON_HIDDEN_MARKER, "true");
        continue;
      }
      if (!isStudioLine(line)) {
        continue;
      }
      const projectId = projectIdOf(line);
      if (projectId === null) {
        continue;
      }
      const group = classification.projects.get(projectId);
      const addonLines = group === void 0 ? [] : group.addonLines;
      const duplicated = group !== void 0 && (group.studioLines.length > 1 || group.addonLines.length > 1);
      if (!duplicated) {
        const merged = mergedPairDisplay(line, addonLines.length === 1 ? addonLines[0] : null);
        const priceElement = block.querySelector(config2.linePriceSelector);
        if (priceElement !== null) {
          barrier.setText(priceElement, formatMinorUnits(merged.final_price, cart.currency, locale));
        }
        const quantityElement = block.querySelector(config2.lineQuantityValueSelector);
        if (quantityElement !== null) {
          setQuantityValue(barrier, quantityElement, merged.quantity);
        }
        barrier.setAttribute(block, MERGED_MARKER, "1");
        barrier.setAttribute(block, PROJECT_MARKER, projectId);
      }
      applyWarnElement(barrier, document2, block, config2, warnedProjects.has(projectId));
    }
    const correctedCount = correctedItemCount(cart);
    const countText = String(correctedCount);
    for (const selector of config2.countSurfaceSelectors) {
      for (const surface of document2.querySelectorAll(selector)) {
        barrier.setText(surface, countText);
        barrier.setAttribute(surface, COUNT_MARKER, countText);
      }
    }
    applyCheckoutButtons(barrier, document2, config2, warnActive);
    return { writes: barrier.writes, warnActive, correctedCount };
  }

  // src/boot.ts
  var MAX_FOLLOW_UPS = 3;
  var DEFAULT_OBSERVER_DEBOUNCE_MS = 16;
  function syncOp() {
    return {
      name: "sync",
      coalesceKey: "sync",
      plan(cart) {
        const requests = [];
        for (const op of opsForScan(scanCart(cart))) {
          requests.push(...op.plan(cart));
        }
        return requests;
      }
    };
  }
  function hasActionable(cart) {
    return scanCart(cart).verdicts.some((verdict) => isActionableVerdict(verdict));
  }
  function resolveSectionContainers(document2, containerSelectors, sectionIdAttribute) {
    var _a, _b, _c, _d;
    const stampSelector = `[${sectionIdAttribute}]`;
    const resolved = {};
    for (const containerSelector of containerSelectors) {
      const container = document2.querySelector(containerSelector);
      if (container === null) {
        continue;
      }
      const stamped = (_b = (_a = container.matches(stampSelector) ? container : null) != null ? _a : container.querySelector(stampSelector)) != null ? _b : container.closest(stampSelector);
      const sectionId = (_d = (_c = stamped == null ? void 0 : stamped.getAttribute(sectionIdAttribute)) == null ? void 0 : _c.trim()) != null ? _d : "";
      if (sectionId === "") {
        continue;
      }
      if (!(sectionId in resolved)) {
        resolved[sectionId] = containerSelector;
      }
    }
    return resolved;
  }
  function createSectionsSwapper(document2, sectionContainers) {
    return (html) => {
      for (const [sectionId, sectionHtml] of Object.entries(html)) {
        const selector = sectionContainers[sectionId];
        if (selector === void 0) {
          continue;
        }
        const container = document2.querySelector(selector);
        if (container === null) {
          continue;
        }
        const parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
        const replacement = parsed.querySelector(selector);
        container.innerHTML = replacement === null ? sectionHtml : replacement.innerHTML;
      }
    };
  }
  function bootTheme(options) {
    var _a;
    const { document: document2, queue, config: config2 } = options;
    const debounceMs = (_a = config2.observerDebounceMs) != null ? _a : DEFAULT_OBSERVER_DEBOUNCE_MS;
    let disposed = false;
    let displayPasses = 0;
    let observerSchedules = 0;
    let writesTotal = 0;
    let followUpsSinceStimulus = 0;
    let debounceTimer = null;
    const observedContainers = /* @__PURE__ */ new WeakSet();
    const observer = new MutationObserver(onMutations);
    function observeContainers() {
      for (const selector of config2.observedContainerSelectors) {
        for (const container of document2.querySelectorAll(selector)) {
          if (!observedContainers.has(container)) {
            observedContainers.add(container);
            observer.observe(container, { childList: true, subtree: true });
          }
        }
      }
    }
    function staleStorage() {
      var _a2, _b;
      try {
        return (_b = (_a2 = document2.defaultView) == null ? void 0 : _a2.localStorage) != null ? _b : null;
      } catch (e) {
        return null;
      }
    }
    function runPass(cart) {
      displayPasses += 1;
      const result = runDisplayPass(
        document2,
        cart,
        config2.display,
        readStaleProjects(cart, staleStorage())
      );
      writesTotal += result.writes;
      observeContainers();
      observer.takeRecords();
    }
    function withFollowUp(op) {
      return {
        name: op.name,
        coalesceKey: op.coalesceKey,
        plan: (cart) => op.plan(cart),
        onSettled(outcome) {
          var _a2;
          (_a2 = op.onSettled) == null ? void 0 : _a2.call(op, outcome);
          if (disposed || !outcome.ok || outcome.cart === null) {
            return;
          }
          if (hasActionable(outcome.cart) && followUpsSinceStimulus < MAX_FOLLOW_UPS) {
            followUpsSinceStimulus += 1;
            queue.enqueue(withFollowUp(syncOp()));
          }
        }
      };
    }
    function enqueueSync() {
      queue.enqueue(withFollowUp(syncOp()));
    }
    function onExternalStimulus() {
      followUpsSinceStimulus = 0;
      enqueueSync();
    }
    const unsubscribe = queue.subscribe((snapshot) => {
      runPass(snapshot);
    });
    function projectIdFromEventTarget(target) {
      if (!(target instanceof Element)) {
        return null;
      }
      const block = target.closest(config2.display.lineItemSelector);
      if (block === null) {
        return null;
      }
      const key = block.getAttribute(config2.display.lineKeyAttribute);
      if (key !== null) {
        const snapshot = queue.snapshot();
        if (snapshot !== null) {
          const line = snapshot.items.find((item) => item.key === key);
          if (line !== void 0 && isStudioLine(line)) {
            return projectIdOf(line);
          }
          if (line !== void 0) {
            return null;
          }
        }
      }
      return block.getAttribute("data-sg-project");
    }
    function matchesWithin(target, selector) {
      return target instanceof Element && target.closest(selector) !== null;
    }
    function onChangeEvent(event) {
      if (!matchesWithin(event.target, config2.quantityControlSelector)) {
        return;
      }
      followUpsSinceStimulus = 0;
      const projectId = projectIdFromEventTarget(event.target);
      queue.enqueue(withFollowUp(projectId !== null ? coupleOp(projectId) : syncOp()));
    }
    function onClickEvent(event) {
      if (!matchesWithin(event.target, config2.removeControlSelector)) {
        return;
      }
      followUpsSinceStimulus = 0;
      const projectId = projectIdFromEventTarget(event.target);
      queue.enqueue(withFollowUp(projectId !== null ? healOrphanOp(projectId) : syncOp()));
    }
    document2.addEventListener("change", onChangeEvent, true);
    document2.addEventListener("click", onClickEvent, true);
    function onThemeCartEvent() {
      if (queue.isOwnUpdate()) {
        return;
      }
      onExternalStimulus();
    }
    for (const eventName of config2.cartEventNames) {
      document2.addEventListener(eventName, onThemeCartEvent, true);
    }
    const bootView = document2.defaultView;
    function onStorageEvent(event) {
      var _a2;
      if (disposed) {
        return;
      }
      const key = (_a2 = event.key) != null ? _a2 : null;
      if (key !== null && !key.startsWith(STALE_FLAG_PREFIX)) {
        return;
      }
      const snapshot = queue.snapshot();
      if (snapshot !== null) {
        runPass(snapshot);
      }
    }
    bootView == null ? void 0 : bootView.addEventListener("storage", onStorageEvent);
    function onMutations() {
      if (disposed || queue.isOwnUpdate()) {
        return;
      }
      observerSchedules += 1;
      if (debounceTimer !== null) {
        clearTimeout(debounceTimer);
      }
      debounceTimer = setTimeout(() => {
        debounceTimer = null;
        if (disposed) {
          return;
        }
        const snapshot = queue.snapshot();
        if (snapshot !== null) {
          runPass(snapshot);
        }
        onExternalStimulus();
      }, debounceMs);
    }
    observeContainers();
    onExternalStimulus();
    return {
      dispose() {
        disposed = true;
        unsubscribe();
        document2.removeEventListener("change", onChangeEvent, true);
        document2.removeEventListener("click", onClickEvent, true);
        for (const eventName of config2.cartEventNames) {
          document2.removeEventListener(eventName, onThemeCartEvent, true);
        }
        bootView == null ? void 0 : bootView.removeEventListener("storage", onStorageEvent);
        observer.disconnect();
        if (debounceTimer !== null) {
          clearTimeout(debounceTimer);
          debounceTimer = null;
        }
      },
      displayPassCount() {
        return displayPasses;
      },
      observerScheduleCount() {
        return observerSchedules;
      },
      totalWrites() {
        return writesTotal;
      }
    };
  }

  // entry/theme.ts
  var CART_SECTION_SELECTOR = '[id$="__cart-section"]';
  var CART_DRAWER_SELECTOR = "cart-drawer-component";
  var SECTION_ID_ATTRIBUTE = "data-section-id";
  var CART_SURFACE_SELECTORS = [CART_SECTION_SELECTOR, CART_DRAWER_SELECTOR];
  var config = {
    display: {
      // One element per rendered cart line, page AND drawer (both surfaces
      // render through snippets/cart-products.liquid, plan/02-theme-audit.md
      // §1). data-sg-line-key="{{ item.key }}" is stamped on the line's root
      // element by the 4.4 cart-products.liquid edit (VENDORING.md item 3):
      // key-based attribution keeps this exact under Shopify's line merging,
      // where variant-id attribution is ambiguous (note §2).
      lineItemSelector: "[data-sg-line-key]",
      lineKeyAttribute: "data-sg-line-key",
      // Price element inside a line block; stamped alongside the key hook by
      // 4.4 (cart-products.liquid renders item.final_line_price today —
      // plan/02-theme-audit.md §5 "the theme renders item.final_price as-is").
      linePriceSelector: "[data-sg-line-price]",
      // Quantity input inside a line block. name="updates[]" is Shopify's
      // standard cart-form control name (the cart form posts updates[]);
      // PROVISIONAL against Horizon's cart-products.liquid quantity markup.
      lineQuantityValueSelector: 'input[name="updates[]"]',
      // The three count surfaces of plan/09 §1.2 (header bubble, drawer
      // title, cart page heading). 4.4 stamps data-sg-count-surface on each,
      // in the same Liquid edit that renders the corrected count at first
      // paint (note §7; VENDORING.md item 1) — the stamped element contains
      // only the number.
      countSurfaceSelectors: ["[data-sg-count-surface]"],
      // Cart page checkout button: id="checkout" is real audited provenance
      // (snippets/cart-summary.liquid:266-271, plan/02-theme-audit.md §3.8 —
      // the same id the Printbox validator blocked, precedent for the §15 Q3
      // disable). The drawer's footer button is PROVISIONAL: 4.4 stamps
      // data-sg-checkout on it (drawer and page never render in the same
      // document — the drawer renders only off the cart page,
      // plan/02-theme-audit.md §1).
      checkoutButtonSelectors: ["#checkout", "[data-sg-checkout]"],
      // Styling hook for the injected warn element; the class is defined (or
      // renamed) by the 4.4 theme CSS, so it carries no styling contract here.
      warnClassName: "sgp-cart-warn"
    },
    // The theme's own quantity control, delegation-matched on document.
    // Standard cart-form control name; PROVISIONAL (4.4 review).
    quantityControlSelector: 'input[name="updates[]"]',
    // The theme's own remove control. Horizon renders remove as a link to the
    // cart change route (Theme.routes.cart_change_url global exists —
    // plan/02-theme-audit.md §6); the data-sg-remove hook is the 4.4-stamped
    // fallback for button-based markup. PROVISIONAL (4.4 review).
    removeControlSelector: '[data-sg-remove], a[href*="/cart/change"]',
    // Theme cart events observed on document. CartAddEvent is audited
    // provenance (assets/cart-drawer.js:28-33 auto-opens the drawer on it,
    // plan/02-theme-audit.md §6); the cart:update name is Horizon's generic
    // update event, PROVISIONAL (4.4 review).
    cartEventNames: ["CartAddEvent", "cart:update"],
    // Containers the MutationObserver watches — the two cart surfaces, the
    // same list the section-id resolution reads (CART_SURFACE_SELECTORS above).
    observedContainerSelectors: CART_SURFACE_SELECTORS
  };
  (function main() {
    if (typeof document === "undefined") {
      return;
    }
    if (document.documentElement.hasAttribute("data-sgp-cart-pairing")) {
      return;
    }
    document.documentElement.setAttribute("data-sgp-cart-pairing", "1");
    if (typeof MutationObserver !== "function" || typeof fetch !== "function") {
      return;
    }
    function start() {
      const sectionContainers = resolveSectionContainers(
        document,
        CART_SURFACE_SELECTORS,
        SECTION_ID_ATTRIBUTE
      );
      const sectionIds = Object.keys(sectionContainers);
      const baseUrl = readStoreRoot();
      const client = createCartClient(
        sectionIds.length > 0 ? {
          baseUrl,
          sections: {
            ids: sectionIds,
            // The path the requested ids are resolved against. The cart
            // page's section id exists only on the cart template, so
            // without this the bundled section rendering can return
            // nothing for it — the same silent-inert failure the stamped
            // ids fix. Mirrors the theme's own cart JS exactly
            // (assets/component-cart-items.js:151-156, which sends
            // `sections_url: window.location.pathname`); document.location
            // is the same value, read DOM-natively.
            url: document.location.pathname,
            onSections: createSectionsSwapper(document, sectionContainers)
          }
        } : { baseUrl }
      );
      const queue = createCartQueue(client);
      bootTheme({ document, queue, config });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start, { once: true });
    } else {
      start();
    }
  })();
})();
